import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-790f09ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "network"
}
const _hoisted_2 = {
  key: 0,
  class: "df mt-15 search-wrapper"
}
const _hoisted_3 = { class: "mr-8 w-100" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = {
  key: 1,
  class: "network"
}
const _hoisted_6 = { class: "d-content" }
const _hoisted_7 = { class: "d-content__left" }
const _hoisted_8 = { class: "d-aside" }
const _hoisted_9 = { class: "d-aside__main-menu" }
const _hoisted_10 = { class: "d-content__right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_app_search = _resolveComponent("app-search")!
  const _component_add_group_image = _resolveComponent("add-group-image")!
  const _component_app_header = _resolveComponent("app-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_app_navigation = _resolveComponent("app-navigation")!
  const _component_spaces_pop_up = _resolveComponent("spaces-pop-up")!
  const _component_add_group = _resolveComponent("add-group")!
  const _component_app_beta_user_pop_up = _resolveComponent("app-beta-user-pop-up")!
  const _component_app_no_message = _resolveComponent("app-no-message")!
  const _component_desktop_header = _resolveComponent("desktop-header")!
  const _component_drive_aside_main_menu = _resolveComponent("drive-aside-main-menu")!

  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_ctx.hideHeader)
          ? (_openBlock(), _createBlock(_component_app_header, {
              key: 0,
              class: "header"
            }, {
              "top-right": _withCtx(() => [
                (_ctx.isManageContacts && _ctx.showManage)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: "manage",
                      class: "back-link"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$localize('contacts.header.options.manage')), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.showDone)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      href: "javascript:void(0);",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onDone && _ctx.onDone(...args))),
                      class: "back-link"
                    }, _toDisplayString(_ctx.$localize('contacts.header.options.done')), 1))
                  : _createCommentVNode("", true),
                (_ctx.navigationPage === _ctx.NAVIGATION_PAGES.SPACES_GROUPS && !_ctx.spacesStore.usersToAdd.length)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 2,
                      to: "members",
                      class: "back-link"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$localize('contacts.header.options.add_later')), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              bottom: _withCtx(() => [
                (!_ctx.hideSearch)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_app_search, {
                          modelValue: _ctx.spacesStore.search,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.spacesStore.search) = $event)),
                          onClear: _cache[2] || (_cache[2] = ($event: any) => (_ctx.spacesStore.search = '')),
                          placeholder: _ctx.$localize(_ctx.searchPlaceholder)
                        }, null, 8, ["modelValue", "placeholder"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showGroupImage)
                  ? (_openBlock(), _createBlock(_component_add_group_image, { key: 1 }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_view, {
            onSetGroupData: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addDataToGroup($event))),
            onShowPopUp: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showPopUp = true))
          }),
          (!_ctx.hideBottomNav)
            ? (_openBlock(), _createBlock(_component_app_navigation, {
                key: 0,
                "navigation-data": _ctx.navigationData
              }, null, 8, ["navigation-data"]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.showPopUp)
          ? (_openBlock(), _createBlock(_component_spaces_pop_up, {
              key: 1,
              onHide: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showPopUp = false))
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_add_group, { ref: "groupCreate" }, null, 512),
        (_ctx.spacesStore.showBetaUserPopUp)
          ? (_openBlock(), _createBlock(_component_app_beta_user_pop_up, {
              key: 2,
              onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.spacesStore.showBetaUserPopUp = false))
            }))
          : _createCommentVNode("", true),
        _withDirectives(_createVNode(_component_app_no_message, {
          icon: _ctx.noDataMessage.icon
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.noDataMessage.text), 1)
          ]),
          _: 1
        }, 8, ["icon"]), [
          [_vShow, !_ctx.spacesStore.filteredMyContacts.length && _ctx.navigationPage === _ctx.NAVIGATION_PAGES.SPACES_MANAGE]
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
        _createVNode(_component_desktop_header),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("aside", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_drive_aside_main_menu)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_router_view, {
              onSetGroupData: _cache[7] || (_cache[7] = ($event: any) => (_ctx.addDataToGroup($event))),
              onShowPopUp: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showPopUp = true))
            }),
            (!_ctx.hideBottomNav)
              ? (_openBlock(), _createBlock(_component_app_navigation, {
                  key: 0,
                  "navigation-data": _ctx.navigationData,
                  class: "d-navigator"
                }, null, 8, ["navigation-data"]))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.showPopUp)
          ? (_openBlock(), _createBlock(_component_spaces_pop_up, {
              key: 0,
              onHide: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showPopUp = false))
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_add_group, { ref: "groupCreate" }, null, 512),
        (_ctx.spacesStore.showBetaUserPopUp)
          ? (_openBlock(), _createBlock(_component_app_beta_user_pop_up, {
              key: 1,
              onClose: _cache[10] || (_cache[10] = ($event: any) => (_ctx.spacesStore.showBetaUserPopUp = false))
            }))
          : _createCommentVNode("", true)
      ]))
}